const LANGUAGE_STORAGE_KEY = 'language';

type SupportedLanguage = 'en' | 'pt-BR';

export function selectBrowserLanguage(
  browserLanguages: readonly string[],
): SupportedLanguage | undefined {
  for (const language of browserLanguages) {
    try {
      const [canonicalLanguage] = Intl.getCanonicalLocales(language);
      if (canonicalLanguage === 'pt-BR') {
        return 'pt-BR';
      }
      if (canonicalLanguage === 'en' || canonicalLanguage.startsWith('en-')) {
        return 'en';
      }
    } catch {
      // Ignore invalid browser-supplied language tags.
    }
  }

  return undefined;
}

export function initializeLanguageFromBrowser(): void {
  try {
    const storage = window.localStorage;
    if (storage.getItem(LANGUAGE_STORAGE_KEY) !== null) {
      return;
    }

    const browserLanguages =
      navigator.languages?.length > 0
        ? navigator.languages
        : [navigator.language];
    if (selectBrowserLanguage(browserLanguages) === 'pt-BR') {
      storage.setItem(LANGUAGE_STORAGE_KEY, 'pt-BR');
    }
  } catch {
    // The configured English default works when storage is unavailable.
  }
}
